import { render, staticRenderFns } from "./PartnerPreOrdersTable.vue?vue&type=template&id=0ab33f8e&"
import script from "./PartnerPreOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PartnerPreOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports